(function ($) {

    $('.faq_accordion .category').click(function(){
        $('.faq_accordion .category').removeClass('active');
        if ($(this).next('.category-container').is(':visible')) {
            $('.faq_accordion .category').next('.category-container:visible').slideUp(function(){
                $('.faq_accordion .faq-open.active').removeClass('active');
                $('.faq_accordion .content').slideUp();
            });
            return false;
        }
        $(this).addClass('active');
        $('.faq_accordion .category').not($(this)).next('.category-container:visible').slideUp(function(){
            $('.faq_accordion .category-container:hidden .active').removeClass('active');
            $('.faq_accordion .category-container:hidden .content').slideUp();
        });
        $(this).next('.category-container').stop().slideDown();
        return false;
    });

    $('.faq_accordion .faq-open').click(function() {
        if ($(this).hasClass('active')) {
            $('.faq_accordion .faq-open.active').removeClass('active');
            $('.faq_accordion .content').slideUp();
            return false;
        }
        $('.faq_accordion .faq-open.active').removeClass('active');
        $(this).addClass('active');
        $('.faq_accordion .content').slideUp();
        $(this).next('.content').stop().slideDown();
        return false;
    });

    if(window.location.hash) {
        let hash = window.location.hash.substring(1);
        if (hash.includes('faq-')) {
            hash = hash.replace('faq-','#');
            console.log(hash)
            let link = $('a[href="'+ hash +'"]');
            if(link.length > 0) {
                link.closest('.category-container').slideDown(function(){                    
                    $('html').animate({
                        scrollTop: link.offset().top - 145
                    }, 950);
                });
                link.click();
            }
        }
    }
  
  })(jQuery);


// WEBPACK FOOTER //
// ./resources/assets/js/partials/faq.js